import { useEffect, useState } from "react";

import { wondaSignupsGated } from "@degaus/shared/brand-config";

import { BASE_URL } from "@/common/links";
import { checkIsWondatwinHost } from "@/common/wondatwin";

export { checkIsWondatwinHost } from "@/common/wondatwin";

export const CLI_SIGNIN_URL = "/signin";
export const CLI_ACCOUNT_URL = "/account";
export const CLI_SIGNUP_URL = "/signup";

/**
 * Signups are waitlist-gated (Tank rejects new accounts): sign-up CTAs read
 * "Join" (never "Join the waitlist") and keep routing to /signup, where the
 * Tank page shows the join form. Flips together with requiresWaitlist in
 * brand-config.
 */
export const SIGNUPS_GATED = wondaSignupsGated();

/**
 * Wraps a sign-up CTA label: the waitlist copy wins while signups are gated.
 * For call sites whose baseline labels are hardcoded English ("Sign up",
 * "Try now"); locale-aware components use their own
 * `SIGNUPS_GATED ? t("waitlist.joinCta") : t(...)` branch instead.
 */
export function signupCtaLabel(label: string): string {
  return SIGNUPS_GATED ? "Join" : label;
}

export function useCanonicalAuthUrl(path: string) {
  const [isWondatwinHost, setIsWondatwinHost] = useState(false);

  useEffect(() => {
    setIsWondatwinHost(checkIsWondatwinHost(window.location.hostname));
  }, []);

  return isWondatwinHost ? `${BASE_URL}${path}` : path;
}
